import Pagination from '@mui/material/Pagination';
import Header from 'components/layouts/Header';
import Menu from 'components/layouts/Menu';
import config from 'config';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useAppDispatch } from 'reducer';
import { errorAlert, successAlert } from 'reducer/slices/alertSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import { showPopup } from 'reducer/slices/popupSlice';
import gather from 'tools/gather';
import utils from 'tools/utils';
import ChangeEmail from './ChangeEmail';
import Check from './Check';

const Transactions = () => {
  const dispatch = useAppDispatch();
  const [data, setData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [searchCoin, setSearchCoin] = useState('');
  const [searchLimit, setSearchLimit] = useState('');
  const [forExcel, setForExcel] = useState('');
  const [searchAmountUp, setSearchAmountUp] = useState('');
  const [searchSide, setSearchSide] = useState('');
  const [searchType, setSearchType] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [searchFromDate, setSearchFromDate] = useState('');
  const [searchToDate, setSearchToDate] = useState('');
  const [searchSearchAll, setSearchSearchAll] = useState('');
  const [searchEmailFail, setSearchEmailFail] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [clear, setClear] = useState(true);
  const [coins, setCoins] = useState<any>([]);

  const listAllCoin = () => {
    const rows: React.ReactElement[] = [];

    coins
      ?.sort((a: any, b: any) => a.symbol.localeCompare(b.symbol))
      .forEach((e: any, i: number) => {
        rows.push(
          <option key={i} value={e.symbol}>
            {e.symbol}
          </option>,
        );
      });

    return rows;
  };

  const sendEmail = async (id: string) => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/transaction/${id}/email`, true).post();

    if (result.code === 200) {
      dispatch(successAlert('Done!'));
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  const inquiry = async (id: string) => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/transaction/${id}/inquiry`, true).get();

    if (result.code === 200) {
      dispatch(showPopup(<Check data={result.data} />));
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  const callback = async (id: string) => {
    dispatch(showLoading());

    const result = await gather(`${config.apiUrl}/v1/admin/transaction/${id}/callback`, true).get();

    if (result.code === 200) {
      dispatch(successAlert('Done'));
    } else {
      dispatch(errorAlert(result.message ?? 'Not connected to server'));
    }

    dispatch(hideLoading());
  };

  const list = () => {
    const rows: React.ReactElement[] = [];

    data.forEach((e: any, i: number) => {
      const ver: any = [];
      Object.entries(e.data! || []).forEach((x: any, k) => {
        ver.push(
          <div key={k} style={{ fontSize: 12 }}>
            <span style={{ color: '#999', fontSize: 12 }}>{x[0]}</span>: {x[1]}
          </div>,
        );
      });

      rows.push(
        <tr key={i}>
          <td>{e._id}</td>
          <td>
            {e.user?.email} - {e.user?.telegram}
          </td>
          <td>
            {ver || '-'}
            {e?.data?.email && e.side === 'send' && e.type === 'voucher' && e.status === 'confirm' && (
              <>
                <span className='changeEmail' onClick={() => dispatch(showPopup(<ChangeEmail id={e._id} />))}>
                  Change Email
                </span>
                <span className='changeEmail sendEmail' onClick={() => sendEmail(e._id)}>
                  Send Email {e.emailFail && <>******</>}
                </span>
              </>
            )}

            {e.side === 'send' && e.type === 'voucher' && e.status === 'confirm' && (
              <span className='changeEmail sendEmail' onClick={() => inquiry(e._id)}>
                STATUS
              </span>
            )}

            {e.try1 && e.try1 !== 200 && e.try2 && e.try2 !== 200 && e.side === 'receive' && (
              <span className='changeEmail sendEmail callback' onClick={() => callback(e._id)}>
                CALLBACK
              </span>
            )}
          </td>
          <td>{utils.formatter(e.amount)}</td>
          <td>{e.fee}</td>
          <td>{e.coin?.symbol}</td>
          <td>{e.side}</td>
          <td>{e.type}</td>
          <td>{e.status}</td>
          <td>
            {e.try1} | {e.try2} | {e.try3}
          </td>
          <td>{moment(e.createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
        </tr>,
      );
    });

    return rows;
  };

  const getCoin = async () => {
    const result = await gather(`${config.apiUrl}/v1/admin/coin`, true).get();
    if (result.code === 200) {
      setCoins(result.data.items.data);
    }
  };

  const dataExcel: any = [['ID', 'Amount', 'Fee', 'Coin', 'Side', 'Type', 'Status', 'Date']];
  dataExport.forEach((e: any) => {
    const ver: any = [];
    Object.entries(e.data! || []).forEach((x: any, k) => {
      if (x[1]) {
        ver.push(x[0] + ':' + x[1]);
      }
    });

    dataExcel.push(
      [
        e._id,
        e.amount,
        e.fee,
        e.coin.symbol,
        e.side,
        e.type,
        e.status,
        moment(e.createdAt)
          .utc()
          .format('YYYY-MM-DD HH:mm:ss'),
      ].concat(ver),
    );
  });

  const init = async () => {
    dispatch(showLoading());

    const from =
      moment(searchFromDate + ' 00:00:00')
        .add(moment.parseZone().utcOffset(), 'm')
        .valueOf() || '';
    const to =
      moment(searchToDate + ' 00:00:00')
        .add(moment.parseZone().utcOffset(), 'm')
        .valueOf() || '';
    const coin = coins.find((e: any) => e.symbol === searchCoin)?._id || '';

    const result = await gather(
      `${config.apiUrl}/v1/admin/transaction?excelManager=${forExcel}&page=${currentPage}${searchEmailFail &&
        `&emailFail=${searchEmailFail}`}&coin=${coin}&searchAll=${searchSearchAll}&side=${searchSide}&amountUp=${searchAmountUp}&type=${searchType}&status=${searchStatus}&fromDate=${from}&toDate=${to}&limit=${(forExcel ===
        'yes' &&
        500000) ||
        searchLimit ||
        50}`,
      true,
    ).get();
    if (result.code === 200) {
      if (forExcel === 'yes') {
        setDataExport(result.data.items.data);
      } else {
        setData(result.data.items.data);
        setCurrentPage(result.data.pages.current);
        setCountPage(result.data.pages.count);
      }
    } else {
      dispatch(errorAlert(result.message));
    }

    dispatch(hideLoading());
  };

  useEffect(() => {
    getCoin();
    init();
  }, [currentPage, clear]);

  return (
    <>
      <Menu />
      <div className='container'>
        <Header />
        <div className='searchPro'>
          <input value={searchSearchAll} placeholder='Hash, Code, Ref, Sender ...' onChange={(e) => setSearchSearchAll(e.target.value)} />
          <input value={searchAmountUp} placeholder='Amount+' onChange={(e) => setSearchAmountUp(e.target.value)} />
          <select value={searchCoin} onChange={(e) => setSearchCoin(e.target.value)}>
            <option>Coin</option>
            {listAllCoin()}
          </select>
          <select value={searchSide} onChange={(e) => setSearchSide(e.target.value)}>
            <option value={''}>Side</option>
            <option value='send'>Send</option>
            <option value='receive'>Receive</option>
          </select>
          <select value={searchType} onChange={(e) => setSearchType(e.target.value)}>
            <option value={''}>Type</option>
            <option value='direct'>Direct</option>
            <option value='voucher'>Voucher</option>
            <option value='swap'>Swap</option>
            <option value='fast'>Fast</option>
            <option value='energy'>Energy</option>
            <option value='system'>System</option>
            <option value='cashBack'>CashBack</option>
          </select>
          <select value={searchStatus} onChange={(e) => setSearchStatus(e.target.value)}>
            <option value={''}>Status</option>
            <option value='confirm'>Confirm</option>
            <option value='reject'>Reject</option>
            <option value='cancel'>Cancel</option>
            <option value='pending'>Pending</option>
            <option value='processing'>Processing</option>
          </select>
          <input type='date' value={searchFromDate} onChange={(e) => setSearchFromDate(e.target.value)} />
          <input type='date' value={searchToDate} onChange={(e) => setSearchToDate(e.target.value)} />
          <select value={searchLimit} onChange={(e) => setSearchLimit(e.target.value)}>
            <option value={''}>Limit</option>
            <option value='50'>50</option>
            <option value='100'>100</option>
            <option value='200'>200</option>
            <option value='300'>300</option>
            <option value='400'>400</option>
            <option value='500'>500</option>
            <option value='1000'>1000</option>
            <option value='2000'>2000</option>
            <option value='5000'>5000</option>
          </select>
          <select value={forExcel} onChange={(e) => setForExcel(e.target.value)}>
            <option value={''}>For Excel</option>
            <option value='no'>No</option>
            <option value='yes'>Yes</option>
          </select>
          <select value={searchEmailFail} onChange={(e) => setSearchEmailFail(e.target.value)}>
            <option value={''}>Email Fail</option>
            <option value='true'>True</option>
            <option value='false'>False</option>
          </select>
          <div
            onClick={() => {
              setCurrentPage(1);
              setClear(!clear);
            }}
          >
            SEARCH
          </div>
          <div
            onClick={() => {
              setSearchLimit('');
              setSearchCoin('');
              setSearchFromDate('');
              setSearchToDate('');
              setSearchSide('');
              setSearchStatus('');
              setSearchType('');
              setSearchSearchAll('');
              setForExcel('');
              setCurrentPage(1);
              setClear(!clear);
              setDataExport([]);
              setSearchEmailFail('');
              setTimeout(() => {
                // init();
              }, 500);
            }}
          >
            CLEAR
          </div>
          {dataExcel.length > 1 && (
            <CSVLink data={dataExcel} filename={'data-export-' + searchSearchAll + '-' + searchFromDate + '-' + searchToDate + '.csv'}>
              EXPORT
            </CSVLink>
          )}
        </div>
        <table className='tableData'>
          <tbody>
            <tr>
              <td>ID</td>
              <td>User</td>
              <td>Hash</td>
              <td>Amount</td>
              <td>Fee</td>
              <td>Coin</td>
              <td>Side</td>
              <td>Type</td>
              <td>Status</td>
              <td>Try</td>
              <td>Date</td>
            </tr>
            {list()}
          </tbody>
        </table>
        <Pagination count={countPage} color='primary' onChange={(_e, v) => setCurrentPage(v)} />
      </div>
    </>
  );
};

export default Transactions;
